import { render } from "./BulkNoticeCallSKD_list.vue?vue&type=template&id=7aa08ab1"
import script from "./BulkNoticeCallSKD_list.vue?vue&type=script&lang=js"
export * from "./BulkNoticeCallSKD_list.vue?vue&type=script&lang=js"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__